<template>
  <div class="container">
    <!-- carousel -->
    <div class="columns">
      <div class="column has-network-bg has-text-left is-size-5 has-text-weight-semibold">
        <div class="columns is-marginless third-height">
          <div class="column has-text-white">
            BLOCKS
          </div>
          <div class="column has-text-info">
            {{ blocks }}
          </div>
        </div>
        <div class="columns is-marginless third-height">
          <div class="column has-text-white">
            LATEST
          </div>
          <div class="column has-text-info">
            {{ lastBlockTime }}
          </div>
        </div>
        <div class="columns is-marginless third-height">
          <div class="column has-text-white">
            TX/SEC
          </div>
          <div class="column has-text-info">
            {{ transactionPerSecond }}
          </div>
        </div>
      </div>
      <div class="column is-9">
        <agile :arrows="false" :speed="1200"
          :autoplaySpeed="5000"
          :timing="'linear'" :fade="true"
          :autoplay="true" :pauseOnHover="false">
          <div class="slide slide--1"></div>
          <div class="slide slide--2"></div>
          <div class="slide slide--3"></div>
        </agile>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'carousel',
    computed: {
      ...mapState(['chainStatus']),
      blocks () {
        return this.$utils.addComma(this.chainStatus.blockHeight)
      },
      lastBlockTime () {
        if (this.chainStatus.lastBlockTime) {
          const last = this.chainStatus.lastBlockTime
          const d = new Date()
          const now = d.getTime()
          if (now / 1000 - last < 30) {
            return '' + parseInt(now / 1000 - last) + 's'
          } else {
            return this.$utils.fromNow(last)
          }
        } else {
          return 'n/a'
        }
      },
      transactionPerSecond () {
        return Number.parseFloat('' + this.chainStatus.transactionsPerHour / 3600).toFixed(3)
      }
    }
  }
</script>

<style lang="scss">
  .agile {
    position: relative;

    &, * {
      &:focus,
      &:active {
        outline: none;
      }
    }

    &__list {
      display: block;
      margin: 0;
      overflow: hidden;
      padding: 0;
      position: relative;
      width: 100%;
    }

    &__track {
      align-items: center;
      display: flex;
      justify-content: flex-start;

      .agile--disabled & {
        display: block;
        max-width: 100%;
      }
    }

    &__slide {
      display: block;

      .agile--fade & {
        opacity: 0;
        position: relative;
        z-index: 0;

        &--active {
          opacity: 1;
          z-index: 2;
        }

        &--expiring {
          opacity: 1;
          transition-duration: 0s;
          z-index: 1;
        }
      }
    }

    &__arrow {
      border: none;
      bottom: -11px;
      margin: 0;
      padding: 0;
      position: absolute;
      transition-duration: .3s;

      &[disabled] {
        cursor: default;
        opacity: .4;
      }

      &:hover {
        svg {
          fill: #333;
        }
      }

      &--prev {
        left: 0;
      }

      &--next {
        right: 0;
      }

      svg {
        fill: #888;
        height: 24px;
        transition-duration: .3s;
      }
    }

    &__dots {
      align-items: center;
      justify-content: center;
      display: block!important;
      list-style: none;
      margin: 20px 0;
      padding: 0;
      text-align: center;
      white-space: nowrap;
    }

    &__dot {
      margin: 0 10px;

      button {
        background-color: #eee;
        border: none;
        border-radius: 50%;
        cursor: pointer;
        display: block;
        height: 10px;
        font-size: 0;
        line-height: 0;
        margin: 0;
        transition-duration: .3s;
        width: 10px;
      }

      &--current,
      &:hover {
        button {
          background-color: #888;
        }
      }
    }
  }

  .agile {
    &__dots {
      bottom: 0;
      display: block!important;
      right: 5px;
      position: absolute;
      transform: none;
      width: 30px;
    }

    &__dot {
      margin-bottom: 10px;

      &:hover {
        button {
          background-color: #333;
        }
      }

      button {
        border: none;
        border-radius: 50%;
        cursor: pointer;
        display: block;
        height: 10px;
        font-size: 0;
        line-height: 0;
        margin: 0;
        transition-duration: .3s;
        width: 10px;
        padding: 0;
        background-color: transparent;
        border: 1px solid #888;
      }

      &--current {
        button {
          background-color: rgba(#000, .4);
        }
      }
    }
  }

  .slide {
    height: 225px;

    &--1 {
      background-image: url("../../assets/banner_1.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100% 100%;
    }

    &--2 {
      background-image: url("../../assets/banner_2.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100% 100%;
    }

    &--3 {
      background-image: url("../../assets/banner_3.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100% 100%;
    }
  }

  .has-network-bg {
    background-image: url("../../assets/network_bg.jpg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-origin: content-box;
    padding: 0;
    margin: 0.75rem;
  }

  .third-height {
    height: 33%;
    line-height: 50px;
    padding-left: 1rem;
    white-space: nowrap;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Carousel.vue